
import { Company } from "@/models/company";
import { AuthService } from "@/services/auth-service";
import Vue from "vue";
import AppCompanyEditNavigation from "./CompanyEditNavigation.vue";
import AppContainerWithScrollProp from "./ContainerWithScrollProp.vue";

export default Vue.extend({
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		},
		noScroll: Boolean
	},
	methods: {
		hasPermission(permission:string):boolean{
			if (!AuthService.user) return false;
			return AuthService.user.hasPermission(permission);
		},
	},
	components: {
		AppCompanyEditNavigation,
		AppContainerWithScrollProp
	}
});
